import defaultState from "./state";

const mantenedorSelReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_MANTENEDOR_CENTROS": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_LISTA_CENTROS": {
      return Object.assign({}, state, {
        listaCentros: action.data,
        listaCentrosFiltrados: action.data,
      });
    }

    case "SET_FILTROS_CENTROS": {
      return Object.assign({}, state, {
        filtrosCentros: action.filtros,
      });
    }

    case "OPEN_CLOSE_MODAL_EDITAR_CENTRO": {
      return Object.assign({}, state, {
        isOpenModalEditar: action.isOpen,
        centro: action.centro,
        isNewCentro: action.isNew,
      });
    }
    case "SET_CENTRO": {
      return Object.assign({}, state, {
        centro: action.centro,
      });
    }

    case "SET_DATA_LISTAS_CENTROS": {
      return Object.assign({}, state, {
        listaPools: action.Pools,
        listaAdditionalExams: action.AdditionalExams,
        listaPsychologicalExams: action.PsychologicalExams,
      });
    }
    case "SET_LISTA_TERRITORIOS": {
      return Object.assign({}, state, {
        listaTerritorios: action.list,
      });
    }
    case "SET_LISTA_CENTROS_FILTRADOS": {
      return Object.assign({}, state, {
        listaCentrosFiltrados: action.lista,
      });
    }

    case "OPEN_CLOSE_MODAL_ELIMINAR_CENTRO": {
      return Object.assign({}, state, {
        isOpenModalEliminar: action.isOpen,
        centro: action.centro,
      });
    }
    case "OPEN_CLOSE_MODAL_DESACTIVAR_CENTRO": {
      return Object.assign({}, state, {
        isOpenModalDesactivar: action.isOpen,
        centro: action.centro,
      });
    }

    case "RESET_STATUS_MANTENEDOR_CENTROS_MODAL": {
      return Object.assign({}, state, {
        centro: {},
      })
    } 

    case "RESET_STATUS_MANTENEDOR_CENTROS": {
      return Object.assign({}, state, {
        isLoading: false,
        listaCentros: [],
        listaCentrosFiltrados: [],
        filtrosCentros: null,
        isOpenModalEditar: false,
        isOpenModalEliminar: false,
        isOpenModalDesactivar: false,
        centro: {},
        isNewCentro: false,
        listaPools: [],
        listaAdditionalExams: [],
        listaPsychologicalExams: [],
        listaTerritorios: [],
      })
    } 

    default:
      return state;
  }
};

export default mantenedorSelReducer;
